{
  "salon-card": {
    "text": {
      "and-x-more": "und {{nr}} mehr",
      "points": "Punkte"
    }
  }
}
